import { createContext, useState, useContext, useMemo } from 'react';
import { NetworkAlertContext } from '../context/NetworkAlertContext';
import { usePreference } from "../context/usePreference";
import { ImageEmissora as ImageEmissoraList } from "../services/ImageEmissoraService";
import { ValidAccessTokenLocalStorage, getAccessTokenLocalStorage } from "../context/utils"
import { updateDateWithTime, subtractMinutes, applySpecificTime } from '../utils/dateTimeUtils';
import { useTranslation } from "react-i18next";
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import moment from "moment";

import {
    doAudienceHandleReturnWithWError401,
    doAudienceHandleReturnWithWError96
} from "../context/AudienceContextUtils";

import PropTypes from 'prop-types';

export const ImageEmissoraContext = createContext();

const ImageEmissoraProvider = ({ children }) => {
    const u = usePreference();
    const [firstTableData, setFirstTableData] = useState([]);
    const { userAuthenticated, setUserAuthenticated, setUserMenssageApi } = useContext(UserPreferenceContext);
    const { setShowError, setInfoSpan, setShowInfo, setInfoError } = useContext(NetworkAlertContext);
    const { t: translateText } = useTranslation();
    const [data, setData] = useState([]);
    const [qtdMinutos, setQtdMinutos] = useState(0);

    const fetchData = async () => {
        setInfoSpan(translateText('network.loadingData'));
        setShowInfo(true);
        let token = getAccessTokenLocalStorage();
        if (ValidAccessTokenLocalStorage()) {
            await ImageEmissoraList(token, qtdMinutos === 0 ? "" : getUltimoNLoading()).then(res => {
                const dadosRating = res?.data?.ListDadosRating;
                doAudienceHandleReturnSuccess(dadosRating);

                const lastHourMinute = dadosRating[0][1];
                u.userPreference.Horario = updateDateWithTime(u.userPreference.Horario, lastHourMinute);

            })
                .catch(err => {
                    doAudienceHandleReturnWithWError(err);
                });
        }
    };
    function doAudienceHandleReturnSuccess(listDadosRating) {
        if (listDadosRating != null) {
            let pRowsHeaders = listDadosRating.map(row => row.slice(0, 3));

            setData(listDadosRating);
            setFirstTableData(pRowsHeaders);
            setShowInfo(false);
        }
    }
    function changeBaseMinuteImage(minute) {
        setQtdMinutos(qtdMinutos + minute);

    }
    function getUltimoNLoading() {
        const dateNow = moment(u.userPreference.Horario, 'YYYY-MM-DDTHH:mm:ss');
        const dateIni = applySpecificTime(dateNow, u.horaIniCalendar);
        const dateForUltimoNLoading = subtractMinutes(dateNow, qtdMinutos, dateIni);
        return dateForUltimoNLoading.format('HH:mm');
    }
    function doAudienceHandleReturnWithWError(resultError) {
        const dataResponse = resultError?.response?.data;
        doAudienceHandleReturnWithWError401(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
        doAudienceHandleReturnWithWError96(dataResponse, setData, null, setShowError, setInfoError);
        doAudienceHandleReturnWithWError98(dataResponse);
    }
    function doAudienceHandleReturnWithWError98(dataResponse) {
        if (Number(dataResponse.CodErro) === 98) {
            const msgErro = dataResponse?.MsgErro;
            setInfoSpan(translateText(msgErro));
            hideShowInfo();
        }
    }
    function hideShowInfo() {
        setTimeout(() => setShowInfo(false), 3000);
    }
    const objMemoProvider = useMemo(
        () => ({
            data,
            firstTableData,
            changeBaseMinuteImage,
            fetchData
        }
        ),
        [
            changeBaseMinuteImage,
            data,
            fetchData,
            firstTableData
        ]
    );
    return (
        <ImageEmissoraContext.Provider value={objMemoProvider}>
            {children}
        </ImageEmissoraContext.Provider>
    );
};
ImageEmissoraProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ImageEmissoraProvider;